module.exports = __webpack_public_path__ + "static/media/crash.2054f10b.mp3";